import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const TaxBox = ({
  data,
  formatAmount,
  maxHeight = 400,
  needFtcAmount = false,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        overflowY: "auto",
        maxHeight,
        pr: 1,
      }}
    >
      {data.map((result, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid",
            borderColor: "divider",
            py: 1,
          }}
        >
          {/* Left section */}
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography
                variant='body1'
                sx={{
                  fontWeight: 600,
                  color: "text.primary",
                  fontSize: "0.95rem",
                }}
              >
                {result.description}
              </Typography>
              {result.calculationSteps &&
                result.calculationSteps.length > 0 && (
                  <Tooltip
                    title={
                      <Box
                        component='div'
                        sx={{
                          whiteSpace: "pre-line",
                          fontSize: "0.875rem",
                          lineHeight: 1.6,
                        }}
                      >
                        {result.calculationSteps
                          .filter((step) => step.trim() !== "")
                          .join("\n")}
                      </Box>
                    }
                    arrow
                    placement='top'
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "info.main",
                        fontSize: 18,
                        cursor: "help",
                        "&:hover": {
                          color: "info.dark",
                        },
                      }}
                    />
                  </Tooltip>
                )}
            </Box>
            <Typography
              variant='caption'
              sx={{
                color: "text.secondary",
                fontSize: "0.75rem",
              }}
            >
              {result.country} • Net Income: {formatAmount(result.netIncome)}
            </Typography>
          </Box>

          {/* Right section */}
          <Box sx={{ display: "flex", gap: 3, mr: 2 }}>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant='caption'
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  display: "block",
                }}
              >
                SG Tax
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 500,
                  fontSize: "0.85rem",
                }}
              >
                {formatAmount(result.singaporeTax, false)}
              </Typography>
            </Box>

            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant='caption'
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  display: "block",
                }}
              >
                Foreign Tax
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 500,
                  fontSize: "0.85rem",
                }}
              >
                {formatAmount(result.foreignTax, false)}
              </Typography>
            </Box>

            {needFtcAmount && (
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  variant='caption'
                  sx={{
                    color: "primary.main",
                    fontSize: "0.7rem",
                    display: "block",
                    fontWeight: 600,
                  }}
                >
                  FTC Amount
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    fontWeight: 700,
                    color: "primary.main",
                    fontSize: "0.95rem",
                  }}
                >
                  {formatAmount(result.ftcAmount, false)}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TaxBox;
